exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".crm-existing-booking-notice {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  margin: 0 0 1em;\n  padding: 10px 14px;\n  border-radius: 6px;\n  border: 1px solid #C9DCEC;\n  border-left: 4px solid #2185D0;\n  background: #F1F7FC;\n  color: #00233B;\n  font-size: 14px;\n  line-height: 1.4;\n}\n.crm-existing-booking-notice > .icon {\n  margin: 2px 0 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader!./~/less-loader!./src/styles/components/crmExistingBookingNotice.less
// module id = 2866
// module chunks = 0